import LayoutFinanceiro from 'app/fuse-layouts/layout-financeiro/LayoutFinanceiro';
import LayoutOnboarding from 'app/fuse-layouts/layout-onboarding/LayoutOnboarding';

const FuseLayouts = {
  LayoutFinanceiro,
  LayoutOnboarding,
};

export default FuseLayouts;
